import ButtonIcon from "#common/buttons/ButtonIcon"
import ChipStatus from "#competence/components/ChipStatus"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { UseContextsQuestion } from "#competence/contexts/ContextsQuestion"
import { preguntaGet } from "#competence/services/Api"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { FiberManualRecord as FiberManualRecordIcon } from "@mui/icons-material"
import InfoIcon from "@mui/icons-material/Info"
import {
	Box,
	Button,
	Chip,
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Skeleton,
	Stack,
	Typography,
} from "@mui/material"
import { Fragment, useMemo } from "react"

export default function CompetenceQuestion({ type }) {
	const { setOpen, setInfo, reload, setQuestionId, setQuestion } = UseContextsQuestion()
	const { competence } = UseContextsCompetence()

	const params = useMemo(
		() => ({ id: competence.id, params: { type } }),
		[competence.id, type]
	)

	const {
		data: questions,
		loading,
		error,
	} = useApi(preguntaGet, { autoFetch: params?.id, params, reload })

	if (loading) return <Skeleton variant="rectangular" height={100} />
	if (error) return <ErrorResponse />

	return (
		<Box>
			<Stack
				direction={"row"}
				spacing={2}
				justifyContent={"space-between"}
				alignContent={"center"}
			>
				<Typography>
					<Typography variant="h7" gutterBottom fontWeight="600" color="text.primary">
						Preguntas:
					</Typography>{" "}
					{questions?.count}
				</Typography>
				{competence.active && (
					<Button
						onClick={() => {
							setOpen("form")
							setQuestion({ type })
						}}
						variant="contained"
					>
						Agregar pregunta
					</Button>
				)}
			</Stack>
			<br />
			<List disablePadding>
				{questions?.data?.map((characteristic, index) => (
					<Fragment key={characteristic.id}>
						<ListItem disableGutters sx={{ py: 1 }}>
							<ListItemIcon sx={{ minWidth: 32 }}>
								<FiberManualRecordIcon
									sx={{
										fontSize: 8,
										color: "primary.main",
										mt: 1,
									}}
								/>
							</ListItemIcon>
							<ListItemText
								primary={characteristic.question}
								secondary={characteristic.created_at}
								primaryTypographyProps={{
									variant: "body1",
									color: "text.primary",
								}}
							/>
							<Stack direction={"row"} spacing={1} alignItems={"center"}>
								<ChipStatus active={characteristic.active} />
								<ButtonIcon
									icon={<InfoIcon />}
									onClick={() => {
										setInfo(true)
										setQuestionId(characteristic.id)
									}}
								/>
							</Stack>
						</ListItem>
						<Divider />
					</Fragment>
				))}
			</List>
		</Box>
	)
}
